<template>
  <MessageBox
    v-if="emailVerified"
    :message="`${this.jobCompany}   ${this.jobName}\n\nに下記の内容で応募いたします。\n内容ご確認の上、ページ最下部の応募ボタンを押下ください。`"
    type="primary"
  />

  <MessageBox v-else type="secondary">
    <p>応募にはメールアドレスの認証が必要になります。</p>
    認証メールを再送信したい場合は、<TextLink primary @click.native="$emit('verify')">こちら</TextLink>をクリックしてください。<br>
    送信されたメール内のリンクをクリックすると、認証が完了します。
  </MessageBox>
</template>

<script>
import MessageBox from '../atoms/MessageBox'
import TextLink from '../atoms/TextLink'

export default {
  name: 'MessageBoxForJobApplication',
  components: { TextLink, MessageBox },
  props: {
    emailVerified: {
      type: Boolean, // boolean | undefined
      required: true,
      default: false,
    },
    jobName: {
      type: String,
      required: true,
      default: '',
    },
    jobCompany: {
      type: String,
      required: true,
      default: '',
    },
  },
}
</script>
